import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
  export class ModalComponent{
  // No se debe cerrar por default true para que haga el shake
  @Input() click = true;
  // El modal se encuentra abierto o no.
  @Input() isOpen = false;
  // Existe la obción de exportar lo que contenga el modal.
  @Input() export = false;
  @Input() iconoExport = 'description';
  // Existen gráficas y genera el cambio en las etiquetas de esta.
  @Input() labels = false;
  @Input() labelsState = false;
  // Esta funcionalidad nos ayuda a eliminar el cerrar de los modales
  @Input() cerrar = true;

  // Emite el evento del cierre del formulario.
  @Output() close = new EventEmitter<void>();
  // Emite el evento del cambio de etiquetas.
  @Output() changeLables = new EventEmitter<void>();
  // Emite el evento de la exportación de archivos.
  @Output() exportFile = new EventEmitter<void>();

  shake = false;

  public onClose(){
    this.close.emit()
  }

  public onChangeLabels(){
    this.changeLables.emit();
  }

  public onExportFile(){
    this.exportFile.emit();
  }

  public clickFuera(event){
    if (event.target === document.getElementById("ampliar") && this.click) {
      document.getElementById("modal").classList.add('moveShake');
      document.getElementById("modal").classList.remove('fadingIn');
      setTimeout(() => {
        document.getElementById("modal").classList.remove('moveShake');
      }, 600);
    }else if(event.target === document.getElementById("ampliar")){
      this.close.emit();
    }
  }


}
